module.exports = __webpack_public_path__ + "static/notification_call-0bd3827ce211051e300b1d97bfae08fb.mp3";